import { QueryFunctionContext } from "@tanstack/react-query";
import { axiosClientCMS } from "../../api/apiClient";

export interface EmployeesInput {
  locale: string;
}

export type Employee = {
  id: number;
  attributes: {
    firstName: string;
    lastName: string;
    position: string;
    bio: string;
    role: string;
    photo: {
      data: {
        id: number;
        attributes: {
          name: string;
          url: string;
        };
      };
    };
    createdAt: string;
    updatedAt: string;
    locale: string;
  };
};

export type EmployeeResponse = {
  meta: any;
  data: Employee[];
};

export const fetchEmployees = async ({
  queryKey,
}: QueryFunctionContext<
  [string, EmployeesInput]
>): Promise<EmployeeResponse> => {
  const [, { ...params }] = queryKey;
  return axiosClientCMS
    .get("/employees", {
      params: {
        ...params,
        populate: "*",
        "pagination[page]": 1,
        "pagination[pageSize]": 50,
      },
    })
    .then((data) => data.data);
};
